export const ROUTE_PATTERNS = {
  MUTUAL_FUND: /\/mutual-fund\/([^\/]+)/,
  REGULAR_PLAN: /\/regular-plan-alert\/([^\/]+)/,
  PAYMENT: /\/payment\/([^\/]+)/,
  ALLOCATION: /\/allocation(\/|$)/
} as const

export const ROUTE_PREFIXES = {
  MUTUAL_FUND: '/mutual-fund/',
  REGULAR_PLAN: '/regular-plan-alert/',
  PAYMENT: '/payment/',
  ALLOCATION: '/allocation'
} as const

export const MAX_RETRY_ATTEMPTS = 4
export const RETRY_DELAY_MS = 1000

export const extractRouteParams = (pathname: string, search: string) => {
  // Extract ISIN from both mutual-fund and regular-plan-alert routes
  const mutualFundMatch = pathname.match(ROUTE_PATTERNS.MUTUAL_FUND)
  const regularPlanMatch = pathname.match(ROUTE_PATTERNS.REGULAR_PLAN)
  const isin = mutualFundMatch?.[1] || regularPlanMatch?.[1] || ''

  const searchParams = new URLSearchParams(search)
  const from = searchParams.get('from') || ''

  // Extract payment type from URL
  const paymentTypeMatch = pathname.match(ROUTE_PATTERNS.PAYMENT)
  const paymentType = paymentTypeMatch?.[1] || ''

  return { isin, from, paymentType }
}

export const getRouteType = (pathname: string) => {
  const isMutualFundRoute = pathname.startsWith(ROUTE_PREFIXES.MUTUAL_FUND)
  const isRegularPlanRoute = pathname.startsWith(ROUTE_PREFIXES.REGULAR_PLAN)
  const isPaymentRoute = pathname.includes(ROUTE_PREFIXES.PAYMENT)
  const isAllocationRoute = pathname.startsWith(ROUTE_PREFIXES.ALLOCATION)

  return {
    isMutualFundRoute,
    isRegularPlanRoute,
    isPaymentRoute,
    isAllocationRoute
  }
}
